<template>
  <ul class="vue-tree fa-ul" v-if="items">
    <template v-for="item of itemsData" :key="item.id">
      <li>
        <span class="fa-li show-on-hover text-break">
          <button
            type="button"
            class="btn btn-sm btn-faded mx-2 my-0 disabled"
            style="padding: 12px"
          ></button>
          <font-awesome-icon :icon="['fal', setIcon(item)]" size="lg" />
          <span v-html="highligthText(item.name)"></span>
          <Popper
            class="btn btn-sm btn-warning m-0 px-3 border-0 hide"
            content="Ver Archivo"
            placement="top"
            hover
            arrow
            @click="setFile(item)"
            offsetDistance="35"
          >
            <font-awesome-icon
              :style="{ color: '#fff' }"
              :icon="['fas', 'eye']"
            />
          </Popper>
        </span>
      </li>
    </template>
  </ul>
</template>

<script>
export default {
  name: "tree",
  emits: ["setFile"],
  props: {
    items: { type: Array },
    tableCreator: { default: true },
    folderStructureName: { default: "" },
    folderList: { type: Array },
    searchTerm: { default: "" }
  },
  data() {
    return {
      selectedItem: null,
      itemsData: null,
      options: [
        "folder",
        "folder-medical",
        "folders",
        "folder-arrow-down",
        "folder-arrow-up",
        "folder-blank",
        "folder-bookmark",
        "folder-gear",
        "folder-grid",
        "folder-heart",
        "folder-image",
        "folder-minus",
        "folder-music",
        "folder-plus",
        "folder-user",
        "folder-xmark",
        "folder-open",
      ],
    };
  },
  mounted() {
    this.itemsData = this.items;
  },
  methods: {
    newItem(item) {
      this.selectedItem = item;
      item.isEdit = false;
      item.newIcon = "folder";
      item.newName = null;
      item.newFolderId = item.folder_structure_id ? item.id : null;
      item.folder_structure_id = item.folder_structure_id
        ? item.folder_structure_id
        : item.id;
      item.newDescription = null;
      item.showForm = true;
      item.id = null;
    },
    editItem(item) {
      this.selectedItem = item;
      item.isEdit = true;
      item.newIcon = item.icon;
      item.newName = item.name;
      item.newFolderId = item.folder_id;
      item.newDescription = item.description;
      item.showForm = true;
    },
    deleteItem(item) {
      let app = this;
      this.axios
        .delete(
          `folder_structures/${item.folder_structure_id}/folders/${item.id}`
        )
        .then(() => {
          app.$emit("setData");
        })
        .catch((error) => {
          console.log(error);
        });
    },
    saveItem(item) {
      let saveData = {
        folder: {
          name: item.newName,
          description: item.newDescription,
          icon: item.newIcon,
          folder_id: item.newFolderId,
        },
      };
      let app = this;
      if (item.id) {
        this.axios
          .put(
            `folder_structures/${item.folder_structure_id}/folders/${item.id}`,
            saveData
          )
          .then(() => {
            item.showForm = false;
            app.$emit("setData");
          })
          .catch((error) => {
            console.log(error);
          });
      } else {
        this.axios
          .post(
            `folder_structures/${item.folder_structure_id}/folders`,
            saveData
          )
          .then(() => {
            item.showForm = false;
            app.$emit("setData");
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },
    setData() {
      this.$emit("setData");
    },
    setFile(item) {
      this.$emit("setFile", item);
    },
    setIcon(item) {
      if (["jgp", "svg", "png"].includes(item.extension)) {
        return "file-image";
      } else if (["doc", "docx"].includes(item.extension)) {
        return "file-word";
      } else if (["xml"].includes(item.extension)) {
        return "file-spreadsheet";
      } else if (["dwg", "pdf"].includes(item.extension)) {
        return "file-pdf";
      } else {
        return "file";
      }
    },
    highligthText(text){
      if (!this.searchTerm) return text
      let regex = new RegExp(`(${this.searchTerm})`, "gi")
      return text.replace(regex, '<span style="font-weight: bold;">$1</span>')
    },
  },
};
</script>
